export enum Currency {
  PLN,
  EUR,
}
